import Vue from 'vue/dist/vue.js'
import MainLayout from "./layouts/Main.vue";

Vue.component('money', {
  props: ['price'],
  computed: {
    formatted() {
      return parseFloat(this.price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
  },
  template: '<span class="money"><span>$</span>{{formatted}}</span>'
})
Vue.component('date', {
  props: ['value', 'format'],
  computed: {
    formatted() {
      return moment(this.value).format(this.format || "YYYY/MM/DD HH:mm");
    }
  },
  template: '<span class="date">{{formatted}}</span>'
})
new Vue(MainLayout).$mount('#app');